import CandidateInfo from "../CandidateInfo";

export default function () {
	return (
		<>
			<div className="card">
				<CandidateInfo header={"Candidate Details"} />
			</div>
		</>
	);
}
